import React, { useState } from "react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Swatch, SHAPES } from "./Legend";

const COLORS = ["#b91c1c", "#ea580c", "#f59e0b", "#15803d", "#0284c7", "#1d4ed8", "#7c3aed", "#db2777", "#111827", "#737373"];

/** DRW-A — the swatch IS the control: tap it to change the symbol's shape, colour and fill.
 *  One popover for the Legend and the Takeoff palette; `onPatch(body)` writes the registry. */
export default function SymbolStyle({ shape, color, fill, unmapped, size = 14, canEdit, onPatch, testId }) {
  const [open, setOpen] = useState(false);
  if (!canEdit || !onPatch) return <Swatch shape={shape} color={color} fill={fill} unmapped={unmapped} size={size} />;
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button type="button" onClick={(e) => e.stopPropagation()} onPointerDown={(e) => e.stopPropagation()}
                className="grid h-7 w-7 shrink-0 place-items-center rounded-md border border-transparent hover:border-neutral-300 hover:bg-neutral-50 data-[state=open]:border-neutral-400"
                aria-label="Change shape, colour or fill" data-testid={testId || "symbol-style"}>
          <Swatch shape={shape} color={color} fill={fill} unmapped={unmapped} size={size} />
        </button>
      </PopoverTrigger>
      <PopoverContent align="start" sideOffset={4} className="w-56 space-y-2 p-2 text-xs" onClick={(e) => e.stopPropagation()} data-testid="symbol-style-popover">
        <div className="text-[10px] font-semibold uppercase tracking-wide text-neutral-500">Shape</div>
        <div className="grid grid-cols-7 gap-1">
          {SHAPES.map((s) => (
            <button key={s} type="button" onClick={() => onPatch({ shape: s })} title={s} data-testid={`symbol-shape-${s}`}
                    className={`grid h-7 w-7 place-items-center rounded-md border ${shape === s ? "border-neutral-900 bg-neutral-100" : "border-neutral-200 hover:bg-neutral-50"}`}>
              <Swatch shape={s} color={color} fill={fill} size={14} />
            </button>
          ))}
        </div>
        <div className="text-[10px] font-semibold uppercase tracking-wide text-neutral-500">Colour</div>
        <div className="grid grid-cols-10 gap-1">
          {COLORS.map((c) => (
            <button key={c} type="button" onClick={() => onPatch({ color: c })} aria-label={c} data-testid={`symbol-color-${c.slice(1)}`}
                    className={`h-5 w-5 rounded-full border-2 ${color === c ? "border-neutral-900 scale-110" : "border-transparent"}`} style={{ background: c }} />
          ))}
        </div>
        <label className="flex items-center gap-2 pt-1">
          <input type="checkbox" checked={!!fill} onChange={(e) => onPatch({ fill: e.target.checked })} className="h-4 w-4 accent-neutral-900" data-testid="symbol-fill" />
          Filled
        </label>
      </PopoverContent>
    </Popover>
  );
}
